import { Pipe, PipeTransform } from '@angular/core';

import { abbreviate } from 'Angular/utils/string-utils';

/**
 * Abbreviates each word in a string to 7 characters
 *
 * Params:
 *   string: The string with words to be abbreviated.
 */
@Pipe({
    standalone: false,
    name: 'abbreviate',
})
export class AbbreviatePipe implements PipeTransform {
    transform(string: string, abbreviationLength?: number): string {
        return abbreviate(string, abbreviationLength);
    }
}
